import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import { DialogStyle } from 'constants';
import { getDialogHeading } from 'utils/commonUtils';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RawProgress from './RawProgress';
import Tags from './Tags';
import AttendanceDataList from './attendanceData/AttendanceDataList';
import { AccordionBox } from 'components/Ui/styled';
import AdditionalInformation from './AdditionalInformation';
import StudentAssets from './studentAssets/StudentAssets';

const StudentDetailsViewMore = (props) => {
  const { open, setOpen } = props;
  const [expanded, setExpanded] = useState(false);
  const accordionList = [
    {
      title: 'Attendance Data',
      component: <AttendanceDataList />,
      panel: 'panel1',
    },
    {
      title: 'Raw Progress Data',
      component: <RawProgress />,
      panel: 'panel2',
    },
    {
      title: 'Assets',
      component: <StudentAssets />,
      panel: 'panel3',
    },
    {
      title: 'Tags',
      component: <Tags />,
      panel: 'panel4',
    },
    {
      title: 'Additional Information',
      component: <AdditionalInformation setExpanded={setExpanded} />,
      panel: 'panel5',
    },
  ];
  const [accordionData, setAccordionData] = useState(accordionList);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClose = () => {
    setOpen(false);
    setExpanded(false);
  };

  return (
    <>
      <Dialog open={open} PaperProps={DialogStyle}>
        {getDialogHeading('Student Details', handleClose)}
        {accordionData?.map((item, index) => {
          return (
            <AccordionBox key={index}>
              <Accordion
                defaultExpanded={false}
                expanded={expanded === item.panel}
                onChange={handleChange(item.panel)}
                key={index}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel1a-content'
                  id='panel1a-header'
                >
                  <Typography variant='h6'>{item.title}</Typography>
                </AccordionSummary>
                <AccordionDetails>{item.component}</AccordionDetails>
              </Accordion>
            </AccordionBox>
          );
        })}
      </Dialog>
    </>
  );
};

export default StudentDetailsViewMore;
